import { createTopNavLucideIcon } from "@dashboard/icons/createNavigationLucideIcon";
import { KeyRound } from "lucide-react";

/**
 * The key pages' TopNav destination: back to the key list. Upstream's TopNav
 * (3.23) names each destination with an icon and a tooltip; this section
 * uses the same key icon as its Configuration tile.
 */
export const AtticApiKeysDestinationIcon = createTopNavLucideIcon(KeyRound);
